/** One auto-cached session covers every task assignment of the signed-in user. */
export const TASKS_CONTEXT_KEY = 'tasks';

/** Snapshot of the user's open/pending assignment rows, in list shape. */
export const tasksAssignmentsListKey = 'tasks:assignments';

/** Snapshot of one assignment's detail row, keyed by assignment id. */
export const taskAssignmentKey = (assignmentId: number): string =>
  `task-assignment:${assignmentId}`;

/** Snapshot of one Action in the blended (definition + assignment) shape. */
export const taskActionKey = (taskId: number): string => `task-action:${taskId}`;

export const tasksAssignmentStateMachineKey = 'tasks:assignment-state-machine';

export const tasksDefinitionStateMachineKey = 'tasks:definition-state-machine';

/** Snapshot of the personnel reference section (scope id + compact rows). */
export const tasksPersonnelKey = 'tasks:personnel';

export const tasksComplianceStandardsKey = 'tasks:compliance-standards';

export const tasksProjectsKey = 'tasks:projects';
